webpackJsonp([50739212244294],{

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(283);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(_ref) {
	  var pathContext = _ref.pathContext,
	      data = _ref.data;
	  var tag = pathContext.tag;
	  var _data$allMarkdownRema = data.allMarkdownRemark,
	      edges = _data$allMarkdownRema.edges,
	      totalCount = _data$allMarkdownRema.totalCount;
	
	  var tagHeader = totalCount + " post" + (totalCount === 1 ? "" : "s") + " tagged with \"" + tag + "\"";
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "h1",
	      null,
	      tagHeader
	    ),
	    _react2.default.createElement(
	      "ul",
	      null,
	      edges.map(function (_ref2) {
	        var node = _ref2.node;
	        var title = node.frontmatter.title;
	        var slug = node.fields.slug;
	
	        return _react2.default.createElement(
	          "li",
	          { key: slug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: slug.substring(0, slug.length - 1) },
	            title
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/tags" },
	      "All tags"
	    )
	  );
	};
	
	// Components
	
	
	Tags.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    tag: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      totalCount: _propTypes2.default.number.isRequired,
	      edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        node: _propTypes2.default.shape({
	          fields: _propTypes2.default.shape({
	            slug: _propTypes2.default.string.isRequired
	          }),
	          frontmatter: _propTypes2.default.shape({
	            title: _propTypes2.default.string.isRequired
	          })
	        })
	      }).isRequired)
	    })
	  })
	};
	
	exports.default = Tags;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-tags-js-82a0f78bf0a0428074db.js